import React from 'react';

import './ClientSelection.css'
const ClientSelection = ({
  clients,
  selectedClientId,
  newClient,
  onClientSelect,
  onShowAddClient
}) => {
  return (
    <div className="InvoiceForm__client-selection-section">

      <div className="InvoiceForm__client-row">
        <select
          className="InvoiceForm__select"
          value={selectedClientId}
          onChange={e => onClientSelect(e.target.value)}
        >
          <option value="">-- Select existing client --</option>
          {clients.map(client => (
            <option key={client.id} value={client.id}>
              {client.client_name} - {client.client_company_name}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="InvoiceForm__button InvoiceForm__button--add-client"
          onClick={onShowAddClient}
        >
          + Add Client
        </button>
      </div>

      {(selectedClientId || newClient.name) && (
        <div className="InvoiceForm__client-info">
          <h4 className="InvoiceForm__client-info-title">Selected Client Info</h4>
          <div className="InvoiceForm__client-details">
            <div><strong>Name:</strong> {newClient.name || 'N/A'}</div>
            <div><strong>Email:</strong> {newClient.email || 'N/A'}</div>
            <div><strong>Company:</strong> {newClient.company || 'N/A'}</div>
            <div><strong>GST:</strong> {newClient.gst || 'N/A'}</div>
            <div><strong>Address:</strong> {newClient.address || 'N/A'}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientSelection;
